import {toJS} from "mobx";

import {DataSourceElement} from 'controls/designer/dataSourcesManager/dataSourceElement';
import {IncidentsHealthResponseEntry} from "controls/designer/api";
import {getSeverityFromValueToSeverityMap} from "controls/designer/dataSourcesManager/metricValueAsSeverity";
import {CellIncidentDatasource} from "controls/designer/dataSourcesManager/incidentDataSourceEditor";
import {RemoteEventsManager} from "core/remoteEventsManager";
import {IncidentsRouter} from "areas/incidents/bundleDescription";
import {IncidentCounterEvent} from "areas/incidents/events/incidentCounterEvent";
import {getAccountsLite} from "areas/administration/accounts/api";
import {apiFetch} from "framework/api";


const i18n = require('core/localization').translator({
	'{0} included subaccounts': {
		no: '{0} med subkontoer'
	},
	'Incident count: {0}': {
		no: 'Hendelseantall: {0}'
	}
});

export class IncidentDataSourceElement extends DataSourceElement {
	id: string
	declare datasource: CellIncidentDatasource
	incidentCounter: number

	getEntriesToLoad() {
		return [{
			accountId: this.datasource.accountId,
			includeSubaccounts: this.datasource.includeSubaccounts ?? false,
			incidentCounter: true,
			filter: this.datasource.filters
		}]
	}

	onHealthInfoLoaded(entries: IncidentsHealthResponseEntry[]) {
		if(entries.length){
			this.incidentCounter = entries[0].incidentCounter
		}
	}

	updateState() {
		if(this.incidentCounter == null)
			return

		if(this.datasource.valueAsSeverity.hideMetricValue !== true) {
			this.addContentLabel(this.incidentCounter);
		}

		if (this.datasource.valueAsSeverity.metricValueAsSeverity) {
			let severity = getSeverityFromValueToSeverityMap(this.datasource.valueAsSeverity.metricValueToSeverity, this.incidentCounter)

			this.setState(severity);
		}
	}

	redirect() {
		this.navigator.go({url: IncidentsRouter.list({
			accountId: this.datasource.accountId,
			includeSubaccounts: this.datasource.includeSubaccounts ?? false,
			filters: toJS(this.datasource.filters)
		})});
	}

	accountName: string
	async getTooltipInternal() {
		if (this.accountName == null) {
			let accounts = await apiFetch(getAccountsLite({accountId: this.datasource.accountId}));

			this.accountName = accounts.data.find(x => x.id == this.datasource.accountId)
				?.name;
		}

		let tooltip = ''

		if(this.datasource.includeSubaccounts){
			tooltip = i18n('{0} included subaccounts', this.accountName)
		}else{
			tooltip = this.accountName
		}

		tooltip += "\r\n"

		tooltip += i18n('Incident count: {0}', this.incidentCounter)

		return tooltip
	}

	subscribeDirect(){
		RemoteEventsManager.subscribeCallback(IncidentCounterEvent.subscription({
			accountId: this.datasource.accountId,
			includeSubaccounts: this.datasource.includeSubaccounts ?? false,
			filters: toJS(this.datasource.filters)
		}), (e: IncidentCounterEvent) => {
			this.incidentCounter = e.incidentCounter;
		})
	}

	empty() {
		return this.datasource.accountId == null;
	}
}
